module.exports = __webpack_public_path__ + "static/media/web.f39ed1d9.svg";